import React, { useState } from 'react';
import '../styles/OwnersDropdown.css';
import '../styles/FindPumpsDropdown.css';

const OwnersDropdown = ({ activeDropdown }) => {
  const [selectedCategory, setSelectedCategory] = useState('training');

  const ownerData = {
    training: [
      {
        id: 1,
        name: "Training Signup",
        description: "Register for upcoming training sessions",
        icon: "",
        link: "/training-signup"
      },
      {
        id: 2,
        name: "Basic Operation Training",
        description: "Learn fundamental pump operation and maintenance",
        icon: "",
        link: "/training/basic"
      },
      {
        id: 2,
        name: "Advanced Troubleshooting",
        description: "In-depth diagnostic and repair techniques",
        icon: "",
        link: "/training/advanced"
      },
      {
        id: 3,
        name: "Safety Protocols",
        description: "Essential safety procedures and guidelines",
        icon: "",
        link: "/training/safety"
      }
    ],
    support: [

      {
        id: 1,
        name: "After Market Parts",
        description: "Browse and order replacement parts",
        icon: "",
        link: "/parts"
      },
      {
        id: 2,
        name: "Manuals",
        description: "Download operation and maintenance manuals",
        icon: "",
        link: "/manuals"
      },
      {
        id: 3,
        name: "Warranty Info",
        description: "Check warranty status and coverage details",
        icon: "",
        link: "/warranty"
      },
      {
        id: 4,
        name: "Schedule Service",
        description: "Book maintenance and repair services",
        icon: "",
        link: "/schedule-service"
      }
    ],
    resources: [

      {
        id: 2,
        name: "Application Videos",
        description: "Watch installation and operation guides",
        icon: "",
        link: "/videos"
      },
      {
        id: 3,
        name: "Unique Features",
        description: "Discover advanced product capabilities",
        icon: "",
        link: "/features"
      },
      {
        id: 4,
        name: "Testimonials",
        description: "Read customer success stories",
        icon: "",
        link: "/testimonials"
      }
    ]
  };

  const categories = {
    training: "Training & Education",
    support: "Support & Service",
    resources: "Resources & Media"
  };

  if (activeDropdown !== 'owners') return null;

  return (
    <div className="products-dropdown-overlay">
      <div className="products-dropdown-container">
        {/* Left Sidebar - Categories */}
        <div className="dropdown-sidebar">
          <ul className="category-list">
            {Object.entries(categories).map(([key, label]) => (
              <li key={key}>
                <button 
                  className={`category-item ${selectedCategory === key ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(key)}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
          
          <div className="sidebar-links">
            <a href="/owners" className="sidebar-link">Owner Portal</a>
            <a href="/contact" className="sidebar-link">Contact Support</a>
          </div>
        </div>

        {/* Right Content - Owner Resources Grid */}
        <div className="dropdown-content">
          <div className="content-header">
            <h2 className="content-title">{categories[selectedCategory]}</h2>
          </div>
          
    <div className="items-grid">
      {ownerData[selectedCategory]?.map((item) => (
        <div key={item.id} className="item-card">
          <div className="item-info">
            <h3 className="item-title">{item.name}</h3>
            <div className="item-description">{item.description}</div>
            <a href={item.link} className="item-button">Learn More</a>
          </div>
        </div>
      ))}
    </div>
        </div>
      </div>
    </div>
  );
};

export default OwnersDropdown;